import script from "./ClientCabinetMobileHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientCabinetMobileHeader.vue?vue&type=script&setup=true&lang=js"

import "./ClientCabinetMobileHeader.vue?vue&type=style&index=0&id=5244d06f&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5244d06f"]])

export default __exports__